import React from 'react'
import './aopsSimpleHeader.scss'

const AopsSimpleHeader = ({ title }) => {
  return (
    <div className="aops-simple-header-box">
      <p className="aops-simple-header-title">{title}</p>
    </div>
  )
}

export default AopsSimpleHeader
